import React, { ReactNode } from 'react'
import { CardContainer } from './style'
import { theme } from 'theme'
import Text, { TextColor } from 'particles/Text'
import Divider from 'components/Shared/Divider'

interface SummaryContainerProps {
    title: string
    description?: string
    descriptionColor?: TextColor
    children: ReactNode
}

const SummaryContainer: React.FC<SummaryContainerProps> = ({ title, description, descriptionColor, children }) => {
    return (
        <CardContainer padding={theme.newSpacing.m} showBorder={true}>
            <div className="title-description-container">
                <div>
                    <Text scale="bodyL700" color="primary">
                        {title}
                    </Text>
                    {description && (
                        <Text scale="bodyL500" color={descriptionColor ? descriptionColor : 'secondary'}>
                            {description}
                        </Text>
                    )}
                </div>

                <Divider />
            </div>
            {children}
        </CardContainer>
    )
}

export default SummaryContainer
